import { Injectable } from '@angular/core';

import {BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ScrollBarService {
    constructor() { }

    private subjectDelta: BehaviorSubject<any> = new BehaviorSubject<any>({});
    private subjectOptions: BehaviorSubject<any> = new BehaviorSubject<any>({});
    private subjectScrollDelta: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    setDelta(delta: any) {
        this.subjectDelta.next(delta);
    }

    setScrollDelta(delta: any) {
        this.subjectScrollDelta.next(delta);
    }


    setOptions(options: any) {
        this.subjectOptions.next(options);
    }

    getDelta(): Observable<any> {
        return this.subjectDelta.asObservable();
    }

    getOptions(): Observable<any> {
        return this.subjectOptions.asObservable();
    }

    getScrollDelta(): Observable<any> {
        return this.subjectScrollDelta.asObservable();
    }
}
